// AUDITUI.A2 (#2587) — redaction marker, built as DEFENCE-IN-DEPTH.
//
// The contract permits a non-empty `redactedFields` (packages/shared
// audit-trail.ts), so a component rendering AuditEvents must handle it.
//
// HONEST STATE OF THE DATA, recorded rather than implied: no row in
// production can currently reach this component with a non-empty
// `redactedFields`. A0's redaction has two layers — a field-name denylist
// (/email/i) and a default-deny entity-type allowlist — and no writer of any
// allowlisted entity type emits a key matching that pattern, so the denylist
// never fires on real rows. A0's own dated append to
// Sprint-AUDITUI-adjudication.md says the same thing from the other side
// ("close to decorative" against the real risk class).
//
// It is still correct to build, and the realistic route by which it could
// start rendering is concrete: TENANT_FEATURE_FLAG_UPDATED writes
// `{ [flag]: value }` with the FLAG NAME as the key (tenant.service.ts,
// tenantAdminActions.service.ts), so adding a feature flag whose name
// contains "email" makes those writers produce redactions immediately.
//
// Consequently this component is tested WITH PROPS IN ISOLATION and no
// fixture was created for it: a fixture would assert that production emits a
// shape it cannot emit, which is exactly why fixture 008 was retired.

interface Props {
  /** Field NAMES only — never values. Empty array renders nothing. */
  fields: readonly string[];
}

export default function RedactionMarker({ fields }: Props) {
  if (fields.length === 0) return null;

  const label = fields.length === 1
    ? '1 field hidden'
    : `${fields.length} fields hidden`;

  return (
    <span
      data-testid="audit-redaction-marker"
      title={`Hidden by redaction policy: ${fields.join(', ')}`}
      style={{
        fontSize:     11,
        fontFamily:   'var(--font-body)',
        color:        'var(--text-secondary)',
        border:       '1px dashed var(--border)',
        borderRadius: 4,
        padding:      '1px 6px',
        whiteSpace:   'nowrap',
      }}
    >
      {label}
    </span>
  );
}
